import { useEffect, useState, type RefObject } from 'react';
import { createPortal } from 'react-dom';
import TouchHand from '../primitives/TouchHand';
import './ScrollHint.css';

/** Scrolled this far: the player found out — the hint goes for good. */
const SCROLLED_PX = 24;

/**
 * A hand swiping up over the list: there is more below (the onboarding house
 * list). Nothing moves by itself; the hint leaves at the player's first scroll.
 */
export default function ScrollHint({ scrollRef, active }: { scrollRef: RefObject<HTMLElement | null>; active: boolean }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!active || !el) return;
    const onScroll = () => {
      if (el.scrollTop > SCROLLED_PX) setVisible(false);
    };
    // Wait for the cards to lay out: no hint when everything already fits.
    const start = window.setTimeout(() => setVisible(el.scrollHeight - el.clientHeight > SCROLLED_PX && el.scrollTop <= SCROLLED_PX), 600);
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.clearTimeout(start);
      el.removeEventListener('scroll', onScroll);
      setVisible(false);
    };
  }, [active, scrollRef]);

  if (!visible) return null;
  return createPortal(
    <div className="scroll-hint" aria-hidden="true">
      <span className="scroll-hint__trail" />
      <span className="scroll-hint__hand">
        <TouchHand size={46} pathClassName="scroll-hint__hand-body" />
      </span>
    </div>,
    document.body,
  );
}
